import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, CreditCardIcon, LandmarkIcon, StarIcon } from 'lucide-react';
import { Button } from './ui';
export const Hero = () => {
  return <div className="relative pt-10 pb-16 md:pt-16 md:pb-24 px-4 overflow-hidden" data-id="element-66">
      {/* Aurora glows */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-primary/15 blur-[120px] rounded-full pointer-events-none" data-id="element-67"></div>
      <div className="absolute top-40 right-0 w-[400px] h-[400px] bg-accent/10 blur-[120px] rounded-full pointer-events-none" data-id="element-68"></div>
      <div className="absolute top-20 left-0 w-[300px] h-[300px] bg-blue-500/10 blur-[100px] rounded-full pointer-events-none" data-id="element-69"></div>

      <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-71">
          <div className="inline-block bg-dark-card border border-dark-border rounded-full px-6 py-2 mb-8 mt-[-10px]" data-id="element-72">
            <span className="text-cyan-100 font-medium text-[14px]" data-id="element-73">
              🤖 SUPERKIT IA™{' '}
              <span className="text-cyan-300/50" data-id="element-74">by Global Nova Pro</span>
            </span>
          </div>

          <h1 className="md:text-4xl lg:text-5xl font-black text-white mb-4 text-[24px]" data-id="element-75">
            La biblioteca de productividad con IA{' '}
            <span className="bg-gradient-to-r from-primary via-cyan-300 to-accent bg-clip-text text-transparent" data-id="element-76">
              más completa
            </span>{' '}
            del mercado argentino.
          </h1>

          <p className="text-cyan-100/80 text-lg md:text-xl mb-8 max-w-3xl mx-auto" data-id="element-77">
            SUPERKIT IA™ — Edición Profesional Argentina
          </p>

          <div className="mb-10 flex justify-center" data-id="element-78">
            <img src="https://cdn.magicpatterns.com/uploads/n1wUqqDUTDbyarQkB6dPCw/mockup_IA_-_Editado.png" alt="SUPERKIT IA — 6 Tomos + 6 Bonos" className="w-full max-w-4xl object-contain drop-shadow-[0_20px_60px_rgba(34,211,238,0.35)] pt-[0px] pb-[0px] mt-[-23px]" data-id="element-79" />
          </div>

          <p className="md:text-2xl text-cyan-50 max-w-3xl mx-auto font-medium text-[16px] mt-[-30px] mb-[15px]" data-id="element-80">
            El sistema N°1 para profesionales y emprendedores en Argentina —
            Prompts, sistemas, plantillas y flujos listos. Todo resuelto con
            Inteligencia Artificial.
          </p>

          <p className="text-cyan-200/70 text-sm md:text-base mb-6 font-medium" data-id="element-81">
            💡 100% PDF · ⚡ Acceso en 5 min · 🧠 IA aplicada al trabajo real ·
            📋 Todo incluido
          </p>

          <div className="flex flex-col items-center gap-6" data-id="element-82">
            <Button size="xl" href="#pricing" className="animate-pulse-slow max-w-md w-full text-xl" data-id="element-83">
              🔥 QUIERO MI SUPERKIT IA AHORA
            </Button>

            <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-cyan-100/70 font-medium" data-id="element-84">
              <span className="flex items-center gap-2" data-id="element-85">
                <ShieldCheckIcon size={18} className="text-primary" data-id="element-86" /> Garantía
                7 días
              </span>
              <span className="flex items-center gap-2" data-id="element-87">
                <CreditCardIcon size={18} className="text-primary" data-id="element-88" /> Pago
                seguro
              </span>
              <span className="flex items-center gap-2" data-id="element-89">
                <LandmarkIcon size={18} className="text-primary" data-id="element-90" /> Mercado Pago
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
};
export const SocialProof = () => {
  return <div className="border-y border-dark-border bg-dark-card/50 py-6" data-id="element-91">
      <div className="max-w-6xl mx-auto px-4" data-id="element-92">
        <div className="flex flex-wrap justify-center md:justify-between items-center gap-6 md:gap-4 text-center" data-id="element-93">
          <div className="w-full md:w-auto" data-id="element-94">
            <p className="text-2xl font-bold text-white" data-id="element-95">+500</p>
            <p className="text-sm text-cyan-200/70 uppercase tracking-wider" data-id="element-96">
              profesionales ya lo usan
            </p>
          </div>
          <div className="hidden md:block w-px h-10 bg-dark-border" data-id="element-97"></div>
          <div className="w-full md:w-auto" data-id="element-98">
            <p className="text-2xl font-bold text-white" data-id="element-99">6</p>
            <p className="text-sm text-cyan-200/70 uppercase tracking-wider" data-id="element-100">
              Tomos listos
            </p>
          </div>
          <div className="hidden md:block w-px h-10 bg-dark-border" data-id="element-101"></div>
          <div className="w-full md:w-auto" data-id="element-102">
            <p className="text-2xl font-bold text-white" data-id="element-103">6</p>
            <p className="text-sm text-cyan-200/70 uppercase tracking-wider" data-id="element-104">
              Bonos incluidos
            </p>
          </div>
          <div className="hidden md:block w-px h-10 bg-dark-border" data-id="element-105"></div>
          <div className="w-full md:w-auto flex flex-col items-center" data-id="element-106">
            <div className="flex text-accent mb-1" data-id="element-107">
              {[...Array(5)].map((_, i) => <StarIcon key={i} size={20} fill="currentColor" data-id="element-108" />)}
            </div>
            <p className="text-sm text-cyan-200/70 uppercase tracking-wider" data-id="element-109">
              4.9/5 de valoración
            </p>
          </div>
        </div>
      </div>
    </div>;
};